import { useTranslation } from 'react-i18next';
import { IMG_PATH } from 'constants/config';

const data = [
  {
    title: '了解市場脈動',
    text: ['掌握各檔股票，傳產金融電子一把抓。'],
  },
  {
    title: '找到投資教練',
    text: ['嚴選投資教練，根據股性和投資者的風險接受度，找到最合適的交易策略。'],
  },
  {
    title: '安心跟單，安心上班',
    text: ['每天下午一點二十五分前，收到部位訊號，五分鐘下單，踏上程式交易之路。'],
  },
];

const color = '#152f2e';

const img = `${IMG_PATH}/benefit`;

function Benefit() {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center py-16 text-white" style={{ background: '#d3d1d1' }}>
      <div className="w-4/5 flex flex-col items-center space-y-12 sm:flex-row sm:space-y-0 sm:space-x-12">
        {data.map(({ title, text }, index) => (
          <div key={index} className="flex w-4/5">
            <img className="self-start" src={`${img}${index}.svg`} alt="" />

            <div className="ml-4">
              <div className="text-xl font-bold mb-4" style={{ color }}>
                {t(title)}
              </div>

              {text.map((str) => (
                <div key={str} style={{ color }}>
                  {t(str)}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Benefit;
